module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-headings"
  }, _vm._l((_vm.headings), function(heading) {
    return _c('li', {
      staticClass: "sidebar-heading",
      class: {
        'has-children': _vm.hasChildren(heading.index), visible: _vm.isVisible(heading.level, heading.parent)
      },
      attrs: {
        "data-level": heading.level
      }
    }, [_c('router-link', {
      staticClass: "sidebar-heading-anchor",
      class: {
        active: _vm.activeId === heading.slug
      },
      attrs: {
        "exact": "",
        "to": {
          query: _vm.getQuery(heading)
        }
      },
      domProps: {
        "innerHTML": _vm._s(heading.text.replace(/<(?:.|\n)*?>/gm, ''))
      },
      nativeOn: {
        "click": function($event) {
          _vm.navigate(heading.slug)
        }
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0785f546"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toc.vue
// module id = 99
// module chunks = 0